module.exports = __webpack_public_path__ + "static/media/hero-image-night.1857d35f.png";